import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AddButtonComponent } from './add-button/add-button.component';
import { ApplicationComponent } from './application/application.component';
import { ApplicationsComponent } from './applications.component';
import { ApplicationsRoutingModule } from './applications-routing.module';
import { CreateApplicationComponent } from './create-application/create-application.component';
import { CreateApplicationDcComponent } from './create-application-dc/create-application-dc.component';
import { CoreModule } from 'app/core/core.module';
import { DeleteApplicationComponent } from './delete-application/delete-application.component';
import { RestoreTokenComponent } from './restore-token/restore-token.component';
import { FilterComponent } from './filter/filter.component';
import { FormsModule } from '@angular/forms';
import { HeaderComponent } from './header/header.component';
import { UIModule } from 'app/ui/ui.module';
import { OrdersModule } from 'app/orders/orders.module';
import { PaginationModule } from 'app/pagination/pagination.module';

@NgModule({
    imports: [
        ApplicationsRoutingModule,
        CommonModule,
        CoreModule,
        FormsModule,
        OrdersModule,
        PaginationModule,
        UIModule
    ],
    declarations: [
        AddButtonComponent,
        ApplicationComponent,
        ApplicationsComponent,
        CreateApplicationComponent,
        CreateApplicationDcComponent,
        DeleteApplicationComponent,
        RestoreTokenComponent,
        FilterComponent,
        HeaderComponent
    ],
    entryComponents: [
        CreateApplicationComponent,
        CreateApplicationDcComponent,
        DeleteApplicationComponent,
        RestoreTokenComponent
    ],
    providers: [
    ]
})
export class ApplicationsModule {

}
